import React, { Component, ComponentType } from 'react';
import styled from 'styled-components';

import { ColumnProps, TableProps } from 'antd/lib/table';
import { Table } from './Table';

import { TableColumns, TableRecord } from '../../models';

interface TotalTableProps<T extends TableRecord> extends TableProps<T> {
    valueColumns: TableColumns<T>;
}

const BorderedTableWithoutHeader = (styled(Table)`
    .ant-table-thead {
        display: none;
    }
    tr > td:first-child {
        background: #fafafa;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
    }
` as ComponentType) as new <T>() => Table<T>;

const Header = styled.div`
    background: #fafafa;
`;

export class TotalTable<T extends TableRecord> extends Component<TotalTableProps<T>> {
    readonly headerColumn: ColumnProps<T> = {
        dataIndex: 'concepto',
        align: 'center'
    };

    render() {
        const columns = [this.headerColumn, ...this.props.valueColumns];

        return <BorderedTableWithoutHeader {...this.props} pagination={false} columns={columns} />;
    }
}
